// material
import { Box, ListItemAvatar, ListItemButton, Typography, Stack } from '@mui/material';
import { styled } from "@mui/material/styles";
import { formatDistanceToNow, formatDistanceToNowStrict } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "src/@/components/ui/dropdown-menu"
import { Button } from 'src/@/components/ui/button';
import Iconify from 'src/components/Iconify';
import { Badge } from 'src/@/components/ui/badge';
import classNames from 'src/utils/classNames'
import { Avatar, AvatarFallback, AvatarImage } from 'src/@/components/ui/avatar';

export default function ChatStaffItem({
  chat,
  user,
  deletarGrupo,
  onlineUsers,
  onSelectConversation,
  roomsWithNewMessages,
  isOpenSidebar,
  key,
  selectedChat,
  contactList
}) {

  const room = chat;

  let other = {};

  chat.people.forEach(person => {
    if (user.id !== person._id) other = person;
  });

  if (!other.firstName) {
    other = { ...other, firstName: 'Deleted', lastName: 'User' };
  }

  const title = (chat.isGroup ? chat.title : `${other.firstName} ${other.lastName}`).substr(0, 22);

  let lastMessage = chat.lastMessage;
  let text = '';

  if (!lastMessage && chat.isGroup) text = 'Novo grupo criado';
  if (!lastMessage && !chat.isGroup) text = `Sem mensagens`;

  if (!lastMessage) lastMessage = {};

  if (lastMessage.author === user.id && !chat.isGroup) text += 'Você: ';

  switch (lastMessage.type) {
    case 'file':
      text += 'Enviou um arquivo.';
      break;
    case 'image':
      text += 'Enviou uma foto';
      break;
    default:
      text += (lastMessage.content || '');
  }

  function pegarIniciais(nomeCompleto) {
    return nomeCompleto
      .split(' ') // Divide o nome completo em um array de palavras
      .map(nome => nome.charAt(0).toUpperCase()) // Pega a primeira letra de cada palavra e a transforma em maiúscula
      .slice(0, 3)
      .join(''); // Junta as iniciais em uma única string
  }


  const getStatus = () => {
    if (room) { if (room.isGroup) return null }
    if (onlineUsers.filter(u => u.id === other._id && u.status === 'busy').length > 0) return 'busy';
    if (onlineUsers.filter(u => u.id === other._id && u.status === 'online').length > 0) return 'online';
    if (onlineUsers.filter(u => u.id === other._id && u.status === 'away').length > 0) return 'away';
    return null;
  };


  const AvatarGroup = ({ users }) => {
    const displayedUsers = users.slice(0, 2); // Exibe apenas os dois primeiros
    const remainingCount = users.length - displayedUsers.length; // Conta quantos usuários restam
  
    return (
      <div className="relative w-14 h-14"> {/* Define um container com tamanho relativo */}
        {displayedUsers.map((user, index) => (
          <div
            key={index}
            className={`absolute ${index === 0 ? 'top-0 left-0 z-10' : 'bottom-0 left-4 z-0'} `}
          > {/* Posiciona o primeiro acima e o segundo abaixo */}
            <Avatar className="w-10 h-10">
              <AvatarImage  src={user.avatar} alt={user.nomeFantasia} />
              <AvatarFallback className="bg-slate-200 shadow-md">{pegarIniciais(user.nomeFantasia)}</AvatarFallback>
            </Avatar>
          </div>
        ))}
        {remainingCount > 0 && (
          <div className="absolute bottom-0 right-0 z-20"> {/* Exibe o contador de usuários restantes */}
            <span className="flex items-center justify-center h-5 w-5 rounded-lg bg-violet-500 text-white text-[9px] font-semibold">
              +{remainingCount}
            </span>
          </div>
        )}
      </div>
    );
  };


  function validaAdminGrupo() {
    if (chat) {
      if (chat.people[0]._id === user.id) {
        if (chat.isGroup === true) {
          return <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button className="w-5 h-5" size="icon" variant="outline"><Iconify color="black" width={8} icon="fe:arrow-down" /></Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem className="text-[10px]" onClick={() => { }}>
                Excluir grupo
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        }

      }
    }
  }

  return (
    <div
      key={room._id}
      className={classNames(
        'py-3 px-2 flex items-center gap-2 justify-between rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 relative cursor-pointer select-none',
        chat._id === selectedChat?._id && !contactList &&
        'bg-gray-100 dark:bg-gray-700',
      )}
      role="button"
      onClick={onSelectConversation}
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <div>
          {chat.isGroup ? (
            <AvatarGroup users={chat?.people} />
          ) : (
            <Avatar className="w-14 h-14">
              <AvatarImage src="" alt="lais" />
              <AvatarFallback className="bg-slate-200 shadow-md">{pegarIniciais(title)}</AvatarFallback>
            </Avatar>
          )}


        </div>
        <div className="min-w-0 flex-1">
          <div className="flex justify-between">
            <div className="font-bold heading-text truncate flex gap-3 items-center text-[14px]">
              <span>{title.substr(0, 25)}{title.length > 25 && '...'}</span>
            </div>
          </div>
          <div className="truncate text-[12px]">
            {text.substr(0, 20)}{text.length > 20 && '...'}
          </div>
        </div>
      </div>
      <div className="flex gap-1 flex-col">
        <small className="font-semibold text-xs">
          {room?.lastUpdate && (
            formatDistanceToNowStrict(new Date(room?.lastUpdate), { addSuffix: false, locale: ptBR, includeSeconds: false })
          )}

        </small>
        <div className='flex flex-row justify-end gap-1 items-center'>
        {roomsWithNewMessages.filter(r => room._id === r).length > 0 && (
          <Badge className="bg-primary text-[9px] w-4 h-4 rounded-full flex items-center justify-center">
            {roomsWithNewMessages.filter(r => room._id === r).length}
          </Badge>
        )}
        {validaAdminGrupo()}
       
        </div>
    
      </div>
    </div>
  )

  // return (
  //   <div className={`my-6 w-full border-slate-300  shadow-none ${roomsWithNewMessages.filter(r => room._id === r).length > 0 ? "bg-violet-50" : "bg-white "}`} key={key}>

  //     <Stack direction={"row"}>
  //       <Box sx={{ width: '100%' }}>
  //         <Stack direction="column" spacing={1}>
  //           <Stack key={key} spacing={0.5} direction={'row'}>
  //             <ListItemButton
  //               sx={{ px: 0.5, py: 0 }}
  //               onClick={onSelectConversation}
  //             >

  //               <Stack direction={'column'} sx={{ width: '75%' }}>
  //                 <Stack spacing={1} direction={'row'}>
  //                   <Box className="w-full">
  //                     <div className='flex flex-row'>

  //                       <p className='font-semibold'> {title.substr(0, 25)}{title.length > 25 && '...'}  </p>
  //                       {/* <p className='text-[12px] text-foreground'> {text.substr(0, 20)}{text.length > 20 && '...'}  </p> */}
  //                       {/* <Typography sx={{ fontSize: 10 }}>{chat?.lastMessage?.lastUpdate	}</Typography> */}
  //                     </div>
  //                   </Box>
  //                 </Stack>
  //               </Stack>

  //               <div className='flex flex-col gap-2'>
  //                 {chat.lastMessage && <Typography style={{ fontSize: 9, textAlign: 'right' }}>{formatDistanceToNowStrict(new Date(chat?.lastMessage?.date), { addSuffix: false, locale: ptBR, includeSeconds: false })}</Typography>}
  //                 {validaAdminGrupo()}
  //                 {roomsWithNewMessages.filter(r => room._id === r).length > 0 && (
  //                   <div className="w-4 h-4 flex justify-center items-center bg-violet-500 text-white font-bold text-[9px] rounded-md">
  //                     {roomsWithNewMessages.filter(r => room._id === r).length}
  //                   </div>
  //                 )}

  //                 <p className="text-[10px]"></p>
  //               </div>

  //             </ListItemButton>
  //           </Stack>



  //         </Stack>
  //       </Box>
  //     </Stack>
  //   </div>
  // );
}


